export default __webpack_public_path__ + "static/media/BANNER CIC.69e94d29.png";